import translationEnJSON from './en/translation-en.json';

type translationJsonType = Record<string, string>;

export const translationEn: translationJsonType = translationEnJSON;
